import GeoPoint from '@/models/Shared/GeoPoint';

// Type for attributes sent to the backend (without the 'name' field which is only for display)
export interface MatchedAttributeForMerge {
  attributeId: string;
  source: number;
  agentMatchReason?: string;
  agentMatchConfidence?: number;
  isVerified: boolean;
  // Work type flags and payRate for positions only
  isTemp?: boolean;
  isPerm?: boolean;
  payRate?: number;
}

export default class MergeWorkerRequest {
    updateFields: MergeWorkerFieldUpdates = new MergeWorkerFieldUpdates();
    // Skills
    addSkills: MatchedAttributeForMerge[] = [];
    deleteSkillIds: string[] = [];
    // Qualifications
    addQualifications: MatchedAttributeForMerge[] = [];
    deleteQualificationIds: string[] = [];
    // Positions
    addPositions: MatchedAttributeForMerge[] = [];
    updatePositions: UpdateWorkerPositionForMerge[] = [];
    deletePositionIds: string[] = [];
    // Documents
    tempDocumentUris: string[] = [];
    agenticTaskId?: string;
}

export class MergeWorkerFieldUpdates {
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    mobilePhoneNumber?: string;
    otherPhoneNumber?: string;
    buildingNameNumber?: string;
    streetRoadBlock?: string;
    locality?: string;
    cityTown?: string;
    stateProvinceRegion?: string;
    postZipCode?: string;
    countryCode?: string;
    geometry?: GeoPoint;
    isExactGeo?: boolean;
    biography?: string;
    summary?: string;
    previousExperience?: string;
    dateOfBirth?: string;
    gender?: number;
    maritalStatus?: number;
    nationality?: string;
    nationalInsuranceNumber?: string;
    workTypes?: string[];
    availability?: string[];
    availabilityRestriction?: number;
    isAgreedToMarketing?: boolean;
    emergencyContactName?: string;
    emergencyContactPhoneNumber?: string;
    isUnspentConvictions?: boolean;
    convictionDetails?: string;
    payrollNumber?: string;
    desiredAnnualSalary?: number;
    currentAnnualSalary?: number;
    currentPositionId?: string;
    defaultBranchId?: string;
    defaultDeskId?: string;
}

export class UpdateWorkerPositionForMerge {
    positionId = '';           // The position attribute ID
    // Work types update (if user chose 'new' for workTypes)
    updateWorkTypes = false;
    isTemp?: boolean;
    isPerm?: boolean;
    // Source update (if user chose 'new' for source)
    updateSource = false;
    source?: number;
    agentMatchReason?: string;
    agentMatchConfidence?: number;
    // Pay rate update (if user chose 'new' for payRate)
    updatePayRate = false;
    payRate?: number;
    // Verified status update (if user chose 'new' for isVerified)
    updateIsVerified = false;
    isVerified?: boolean;
}
